export const CAP_URL =
  "https://northwindgrp.sharepoint.com/sites/DocumentLibrary";
export const HELP_DESK_URL = "https://northwindgrp.servicenowservices.com/esc";
